import { Dexes } from '@shared/interfaces/profiles.interface';
import { DEX_NETWORKS } from '@shared/constants/networks-settings';

export const DEX_VALUES: Dexes = DEX_NETWORKS.reduce((acc, curr) => {
    curr.dexes?.forEach(dex => {
        acc[dex.dex] = {
            dex: dex.dexName,
            network: curr.name,
            networkName: curr.network,
            availableStrats: dex.availableStrats || null,
            isDisabled: dex.isDisabled,
            permission: dex.permission,
        }
    });
    return acc;
}, {})



